import { render, staticRenderFns } from "./FormUno.vue?vue&type=template&id=2b4f8686&scoped=true&"
import script from "./FormUno.vue?vue&type=script&lang=js&"
export * from "./FormUno.vue?vue&type=script&lang=js&"
import style0 from "./FormUno.vue?vue&type=style&index=0&id=2b4f8686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f8686",
  null
  
)

export default component.exports